import React from 'react';
import { useNavigate } from 'react-router-dom';
import ImageComponent from '../../common/Image';

const Header = () => {

    const href = "#";
    const navigate = useNavigate();

    const handleBackNavigation = (e) => {
        e.preventDefault();
        navigate('/dashboard');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate('/dashboard');
        }
    };

    return (
        <div className="position-relative ">
            <header className="sticky-top rounded-0">
                <div className="container-fluid topNav-dash">
                    <div className="web-header">
                        <div
                            className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center tablet-content">
                                <a href="Dashboard.html">
                                    <ImageComponent
                                        fileName="cholacd.svg"
                                        style={{ height: "40px" }}
                                        className="img-fluid"
                                        alt="cholacd"
                                    />
                                </a>
                                <h6 className="Pname">CD</h6>
                            </div>
                            <div className="d-flex align-items-center gap-4">
                                <div className="web-search">
                                    <form
                                        className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 position-relative"
                                        role="search"
                                    >
                                        <input
                                            type="search"
                                            className="form-control"
                                            placeholder="Search by Application ID"
                                            aria-label="Search"
                                        />
                                        <div className="has-i ">
                                            <span className="icon-searchnormal text-white"></span>
                                        </div>
                                    </form>
                                </div>
                                <div className="dropdown d-flex align-items-center text-white gap-3">
                                    <div id="#notification">
                                        <div
                                            className="dropdown lh-1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span className="icon-notification01 fs-2"></span>
                                            <span className="noti-count">12</span>
                                        </div>
                                        <ul className="noti dropdown-menu dropdown-menu-end">
                                            <li className="noti-header">
                                                <h5>Notifications</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                ></button>
                                            </li>
                                            <li className="item">
                                                <div className="d-flex align-items-start gap-3">
                                                    <i className="material-symbols-outlined"> notifications </i>
                                                    <div>
                                                        <h6>Problem validating session</h6>
                                                        <dt>Today, 24-10-2024 | 09:37 AM</dt>
                                                        <p className="mb-0">
                                                            There was a problem validating your session. It may
                                                            have expired. Please try reloading this page.
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="item">
                                                <div className="d-flex align-items-start gap-3">
                                                    <i className="material-symbols-outlined"> notifications </i>
                                                    <div>
                                                        <h6>Document Check List</h6>
                                                        <dt>Today, 24-10-2024 | 09:37 AM</dt>
                                                        <p className="mb-0">
                                                            The specific error is: SessionToken NotFound
                                                            Exception. This also may happen if your license has
                                                            expired.
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="#userProfile" className='d-none'>
                                        <a
                                            href="#"
                                            className="d-flex align-items-center link-light text-decoration-none dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <div className="dp rounded-circle">RK</div>
                                            <div className="name">
                                                Hi, Ravi Kumar<br />
                                                Dealer: <span className="text-white">Sree Rajee</span>
                                            </div>
                                        </a>
                                        <ul className="dropdown-menu text-small">
                                            <li>
                                                <a className="dropdown-item" href="#">New project...</a>
                                            </li>
                                            <li><a className="dropdown-item" href="#">Settings</a></li>
                                            <li><a className="dropdown-item" href="#">Profile</a></li>
                                            <li>
                                                <hr className="dropdown-divider" />
                                            </li>
                                            <li><a className="dropdown-item" href="#">Sign out</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mob-header">
                        <div>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="text-white fs-6 d-flex py-2 mt-2 align-items-center gap-1">
                                    <button
                                        className="icon-arrowleftl1 fs-2 btn p-0 border-0 bg-transparent text-white"
                                        onClick={handleBackNavigation}
                                        onKeyDown={handleKeyDown}
                                        tabIndex="0"
                                        role="button"
                                        aria-label="Go back to dashboard"
                                        style={{ cursor: 'pointer' }}
                                    ></button> Notifications</div>
                            </div>
                        </div>

                        <div className="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample"
                            aria-labelledby="offcanvasExampleLabel">
                            <div className="offcanvas-header">
                                <ImageComponent fileName="chola_logo 1.svg" alt="chola_logo" />
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="">
                                <div>
                                </div>
                            </div>
                            <div className="footer">
                                <div id="#userProfile" className='d-none'>
                                    <div className="dp rounded-circle">RK</div>
                                    <div className="name">
                                        Hi, Ravi Kumar<br />
                                        1233@gmail.com: <span className="text-white">Sree Rajee</span>
                                    </div>

                                    <ul className="dropdown-menu text-small">
                                        <li>
                                            <a className="dropdown-item" href="#">New project...</a>
                                        </li>
                                        <li><a className="dropdown-item" href="#">Settings</a></li>
                                        <li><a className="dropdown-item" href="#">Profile</a></li>
                                        <li>
                                            <hr className="dropdown-divider" />
                                        </li>
                                        <li><a className="dropdown-item" href="#">Sign out</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}

export default Header